import {
  Box,
  Flex,
  ListItem,
  Text,
  UnorderedList,
  useColorMode,
  color,
  CaretRightSvg,
  spacing,
} from 'deepstash-ui';
import React, { Dispatch, SetStateAction } from 'react';
import { ReportOptionType } from 'types';

interface OwnProps {
  options: string[];
  setSelectedOption: Dispatch<SetStateAction<ReportOptionType | undefined>>;
  handleReport: (reportType: string) => Promise<void>;
}

export const ReportModalInitialBody: React.FC<OwnProps> = ({
  options,
  setSelectedOption,
  handleReport,
}) => {
  const { colorMode } = useColorMode();

  const handleSelectOption = (option: ReportOptionType) => () => {
    if (option !== 'Something else') {
      handleReport(option);
    }
    setSelectedOption(option);
  };

  return (
    <>
      <Flex
        fontSize="1.75rem"
        lineHeight="2.375rem"
        fontWeight="bold"
        color={color[colorMode].text}
        align="center"
        py="unset"
      >
        <Text>Report</Text>
      </Flex>
      <Box px="0px" pb="25px">
        <Text align="center" mb={spacing.XXL.rem} mt="unset">
          Why are you reporting this?
        </Text>
        <UnorderedList listStyleType={'none'} mt={spacing.L.rem}>
          {options.map((option, index) => (
            <ListItem
              borderTop={`1px solid ${color.light.underground}`}
              paddingY={spacing.XS.rem}
              paddingX={spacing.XXS.rem}
              cursor="pointer"
              _hover={{ backgroundColor: color[colorMode].background }}
              onClick={handleSelectOption(option as ReportOptionType)}
              key={index}
            >
              <Flex justifyContent="space-between" alignItems="center">
                <Text>{option}</Text>
                <CaretRightSvg />
              </Flex>
            </ListItem>
          ))}
        </UnorderedList>
      </Box>
    </>
  );
};
